import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=f6204db8&scoped=true&"
import script from "./Sitemap.vue?vue&type=script&lang=ts&"
export * from "./Sitemap.vue?vue&type=script&lang=ts&"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=f6204db8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6204db8",
  null
  
)

export default component.exports